import { createFileRoute, Outlet } from '@tanstack/react-router';
import { gmGuard } from '@/lib/route-guards';
import { AdminSidebar } from '@/features/admin/components/admin-sidebar';

export const Route = createFileRoute('/gm')({
  beforeLoad: gmGuard,
  component: GmRoute,
});

function GmRoute() {
  return (
    <div className="h-screen bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100">
      <div className="flex h-screen flex-col lg:flex-row">
        <AdminSidebar portalBase="/gm" />
        <Outlet />
      </div>
    </div>
  );
}
